import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "traz-wrap" }
const _hoisted_2 = { class: "filtros" }
const _hoisted_3 = { class: "f-group" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "f-group" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "f-group" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "f-group" }
const _hoisted_10 = { class: "f-group" }
const _hoisted_11 = { class: "f-group" }
const _hoisted_12 = { class: "f-group f-group--wide" }
const _hoisted_13 = { class: "f-acciones" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "tabla-wrap" }
const _hoisted_18 = {
  key: 0,
  class: "estado"
}
const _hoisted_19 = {
  key: 1,
  class: "estado"
}
const _hoisted_20 = {
  key: 2,
  class: "tabla"
}
const _hoisted_21 = { class: "nowrap" }
const _hoisted_22 = { class: "usuario-celda" }
const _hoisted_23 = { class: "usuario-nombre" }
const _hoisted_24 = {
  key: 0,
  class: "muted"
}
const _hoisted_25 = { class: "nowrap" }
const _hoisted_26 = { class: "nowrap muted" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  class: "detalle-row"
}
const _hoisted_29 = { colspan: "8" }
const _hoisted_30 = { class: "detalle" }
const _hoisted_31 = {
  key: 0,
  class: "detalle-col"
}
const _hoisted_32 = {
  key: 1,
  class: "detalle-col"
}
const _hoisted_33 = {
  key: 0,
  class: "paginacion"
}
const _hoisted_34 = { class: "pag-btns" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = ["disabled"]

import { onMounted, reactive, ref } from 'vue'
import {
  listarAuditoria,
  opcionesAuditoria,
  exportarAuditoria,
  type RegistroAuditoria,
  type OpcionesFiltro,
} from '@/services/TrazabilidadService'
import MensajeFlotante from '@/components/MensajeFlotante.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TrazabilidadView',
  setup(__props) {

/**
 * Trazabilidad global de todas las acciones del sistema.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/trazabilidad` (Trazabilidad) — permiso `trazabilidad.ver`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const registros = ref<RegistroAuditoria[]>([])
const opciones = ref<OpcionesFiltro>({ entidades: [], acciones: [], usuarios: [] })
const cargando = ref(false)

const mensajeVisible = ref(false)
const mensajeTexto   = ref('')
const mensajeTipo    = ref<'positivo' | 'error'>('error')

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error' = 'error') {
  mensajeTexto.value   = texto
  mensajeTipo.value    = tipo
  mensajeVisible.value = true
}
const pagina = ref(1)
const ultimaPagina = ref(1)
const total = ref(0)
const expandido = ref<number | null>(null)

const filtros = reactive({
  id_usuario: '' as number | string,
  entidad: '',
  accion: '',
  id_ejecucion: '' as number | string,
  fecha_desde: '',
  fecha_hasta: '',
  q: '',
})

function etiquetaAccion(a: string): string {
  return ({ creado: 'Creación', actualizado: 'Actualización', eliminado: 'Eliminación' } as Record<string, string>)[a] || a
}

function rolDe(r: RegistroAuditoria): string {
  const rol = r.usuario?.roles?.[0]
  return rol ? (rol.label ?? rol.name) : ''
}

const PALETA_ROL = [
  'rol-v1', // azul
  'rol-v2', // naranja
  'rol-v3', // verde
  'rol-v4', // teal
  'rol-v5', // violeta
] as const

function claseBadgeRol(nombre: string): string {
  if (!nombre) return PALETA_ROL[0]
  let hash = 0
  for (let i = 0; i < nombre.length; i++) hash = (hash * 31 + nombre.charCodeAt(i)) >>> 0
  return PALETA_ROL[hash % PALETA_ROL.length]
}

function fecha(iso: string): string {
  if (!iso) return '—'
  const d = new Date(iso)
  return isNaN(d.getTime()) ? iso : d.toLocaleString('es-CO')
}

function formatear(valor: Record<string, unknown> | null): string {
  return valor ? JSON.stringify(valor, null, 2) : ''
}

async function cargar() {
  cargando.value = true
  try {
    const result = await listarAuditoria({ ...filtros, page: pagina.value, per_page: 25 })
    if (result.ok && result.data) {
      registros.value = result.data.data
      pagina.value = result.data.current_page
      ultimaPagina.value = result.data.last_page
      total.value = result.data.total
    } else {
      registros.value = []
      mostrarMensaje(result.error ?? 'No se pudo cargar el registro de trazabilidad.', 'error')
    }
  } finally {
    cargando.value = false
  }
}

function buscar() {
  pagina.value = 1
  cargar()
}

function irPagina(p: number) {
  pagina.value = p
  cargar()
}

function limpiar() {
  filtros.id_usuario = ''
  filtros.entidad = ''
  filtros.accion = ''
  filtros.id_ejecucion = ''
  filtros.fecha_desde = ''
  filtros.fecha_hasta = ''
  filtros.q = ''
  buscar()
}

async function exportar() {
  await exportarAuditoria(filtros, 'csv')
}

onMounted(async () => {
  const r = await opcionesAuditoria()
  if (r.ok && r.data) opciones.value = r.data
  else mostrarMensaje(r.error ?? 'No se pudieron cargar las opciones de filtro.', 'error')
  await cargar()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "header-flex" }, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", null, "Trazabilidad del sistema"),
        _createElementVNode("p", { class: "subtitulo" }, "Registro de todas las acciones realizadas por los usuarios.")
      ])
    ], -1)),
    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "divider" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[11] || (_cache[11] = _createElementVNode("label", null, "Usuario", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filtros.id_usuario) = $event))
        }, [
          _cache[10] || (_cache[10] = _createElementVNode("option", { value: "" }, "Todos", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opciones.value.usuarios, (u) => {
            return (_openBlock(), _createElementBlock("option", {
              key: u.id,
              value: u.id
            }, _toDisplayString(u.name), 9, _hoisted_4))
          }), 128))
        ], 512), [
          [_vModelSelect, filtros.id_usuario]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[13] || (_cache[13] = _createElementVNode("label", null, "Entidad", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filtros.entidad) = $event))
        }, [
          _cache[12] || (_cache[12] = _createElementVNode("option", { value: "" }, "Todas", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opciones.value.entidades, (e) => {
            return (_openBlock(), _createElementBlock("option", {
              key: e,
              value: e
            }, _toDisplayString(e), 9, _hoisted_6))
          }), 128))
        ], 512), [
          [_vModelSelect, filtros.entidad]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[15] || (_cache[15] = _createElementVNode("label", null, "Acción", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filtros.accion) = $event))
        }, [
          _cache[14] || (_cache[14] = _createElementVNode("option", { value: "" }, "Todas", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opciones.value.acciones, (a) => {
            return (_openBlock(), _createElementBlock("option", {
              key: a,
              value: a
            }, _toDisplayString(etiquetaAccion(a)), 9, _hoisted_8))
          }), 128))
        ], 512), [
          [_vModelSelect, filtros.accion]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[16] || (_cache[16] = _createElementVNode("label", null, "Proceso (ejecución)", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filtros.id_ejecucion) = $event)),
          type: "number",
          min: "1",
          placeholder: "ID"
        }, null, 512), [
          [_vModelText, filtros.id_ejecucion]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[17] || (_cache[17] = _createElementVNode("label", null, "Desde", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filtros.fecha_desde) = $event)),
          type: "date"
        }, null, 512), [
          [_vModelText, filtros.fecha_desde]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[18] || (_cache[18] = _createElementVNode("label", null, "Hasta", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filtros.fecha_hasta) = $event)),
          type: "date"
        }, null, 512), [
          [_vModelText, filtros.fecha_hasta]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[19] || (_cache[19] = _createElementVNode("label", null, "Búsqueda", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filtros.q) = $event)),
          type: "text",
          placeholder: "Descripción o entidad…",
          onKeyup: _withKeys(buscar, ["enter"])
        }, null, 544), [
          [_vModelText, filtros.q]
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          class: "btn guardar",
          onClick: buscar,
          disabled: cargando.value
        }, "Filtrar", 8, _hoisted_14),
        _createElementVNode("button", {
          class: "btn salir",
          onClick: limpiar,
          disabled: cargando.value
        }, "Limpiar", 8, _hoisted_15),
        _createElementVNode("button", {
          class: "btn accion",
          onClick: exportar,
          disabled: cargando.value || !registros.value.length
        }, "Exportar CSV", 8, _hoisted_16)
      ])
    ]),
    _createElementVNode("section", _hoisted_17, [
      (cargando.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Cargando…"))
        : (!registros.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Sin registros para los filtros seleccionados."))
          : (_openBlock(), _createElementBlock("table", _hoisted_20, [
              _cache[22] || (_cache[22] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Fecha"),
                  _createElementVNode("th", null, "Usuario"),
                  _createElementVNode("th", null, "Acción"),
                  _createElementVNode("th", null, "Entidad"),
                  _createElementVNode("th", null, "Descripción"),
                  _createElementVNode("th", null, "Proceso"),
                  _createElementVNode("th", null, "IP"),
                  _createElementVNode("th")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(registros.value, (r) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: r.id
                  }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_21, _toDisplayString(fecha(r.created_at)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_22, [
                          (rolDe(r))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(['rol-badge', claseBadgeRol(rolDe(r))])
                              }, _toDisplayString(rolDe(r)), 3))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_23, _toDisplayString(r.usuario?.name ?? '—'), 1)
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['pill', `pill--${r.accion}`])
                        }, _toDisplayString(etiquetaAccion(r.accion)), 3)
                      ]),
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(r.entidad) + " ", 1),
                        (r.entidad_id)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "#" + _toDisplayString(r.entidad_id), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(r.descripcion), 1),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(r.id_ejecucion ? `#${r.id_ejecucion}` : '—'), 1),
                      _createElementVNode("td", _hoisted_26, _toDisplayString(r.ip_address ?? '—'), 1),
                      _createElementVNode("td", null, [
                        (r.valores_anteriores || r.valores_nuevos)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn-mini",
                              onClick: ($event: any) => (expandido.value = expandido.value === r.id ? null : r.id)
                            }, _toDisplayString(expandido.value === r.id ? 'Ocultar' : 'Ver cambios'), 9, _hoisted_27))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (expandido.value === r.id)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                          _createElementVNode("td", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              (r.valores_anteriores)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "detalle-lbl" }, "Antes", -1)),
                                    _createElementVNode("pre", null, _toDisplayString(formatear(r.valores_anteriores)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (r.valores_nuevos)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    _cache[21] || (_cache[21] = _createElementVNode("span", { class: "detalle-lbl" }, "Después", -1)),
                                    _createElementVNode("pre", null, _toDisplayString(formatear(r.valores_nuevos)), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ]))
    ]),
    (!cargando.value && registros.value.length)
      ? (_openBlock(), _createElementBlock("footer", _hoisted_33, [
          _createElementVNode("span", null, _toDisplayString(total.value) + " registro(s) · página " + _toDisplayString(pagina.value) + " de " + _toDisplayString(ultimaPagina.value), 1),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("button", {
              class: "btn guardar",
              disabled: pagina.value <= 1,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (irPagina(pagina.value - 1)))
            }, "Anterior", 8, _hoisted_35),
            _createElementVNode("button", {
              class: "btn guardar",
              disabled: pagina.value >= ultimaPagina.value,
              onClick: _cache[8] || (_cache[8] = ($event: any) => (irPagina(pagina.value + 1)))
            }, "Siguiente", 8, _hoisted_36)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(MensajeFlotante, {
      visible: mensajeVisible.value,
      mensaje: mensajeTexto.value,
      tipo: mensajeTipo.value,
      onCerrar: _cache[9] || (_cache[9] = ($event: any) => (mensajeVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"])
  ]))
}
}

})